import { format } from "date-fns";
import { uk } from "date-fns/locale";

import { capitalizeFirstLetter } from "./capitalize";

export type TDate = string | number | Date | undefined;

export const dateToReadable = (date: TDate, capitalize = false) => {
  if (!date) return null;

  const formattedDate = format(new Date(date), "EEEE, dd.MM.yyyy", {
    locale: uk,
  });

  if (capitalize) {
    return capitalizeFirstLetter(formattedDate);
  }
  return formattedDate;
};

export const dateToDDMM = (date: TDate) => {
  if (!date) return null;

  const formattedDate = format(new Date(date), "dd.MM", {
    locale: uk,
  });

  return formattedDate;
};
